import {AxiosObservable} from "axios-observable/dist/axios-observable.interface";
import {DadosAluno} from "@/models/sie-pedidos/dadosAluno";
import {DadosParaSolicitacao} from "@/models/sie-pedidos/dadosParaSolicitacao";
import {SolicitacaoApi} from "@/api/sie-pedidos/solicitacao.api";


const api = new SolicitacaoApi();

const getStatusSolicitacao = (cpf: string, tipoSolicitacaoId: number): AxiosObservable<any> =>{
  return api.getStatusSolicitacao(cpf, tipoSolicitacaoId)
}
const getStatusAlunoSolicitacao = (dados: object): AxiosObservable<any> =>{
  return api.getStatusAlunoSolicitacao(dados)
}

const gerarSolicitacao = (formData: FormData): AxiosObservable<any> =>{
  return api.gerarSolicitacao(formData)
}
const getDadosParaSolicitacao = (): AxiosObservable<DadosParaSolicitacao> =>{
  return api.getDadosParaSolicitacao()
}

const getDadosEndereco = (cep: string): AxiosObservable<DadosAluno> => {
  return api.getDadosEndereco(cep);
};

const segundaVia = (cpf: string): AxiosObservable<any> =>{
  return api.segundaVia(cpf)
}

const getDocumentos = (cpf: string): AxiosObservable<DadosAluno> =>{
  return api.getDocumentos(cpf);
}

export default {
  getStatusSolicitacao,
  gerarSolicitacao,
  getDadosParaSolicitacao, getDadosEndereco,
  getStatusAlunoSolicitacao, segundaVia,
  getDocumentos
}
